function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg404ErrorwithportalsCuate({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-48"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.44,392.15c129.77-.62,275.35-.62,405.12,0-129.77.61-275.35.61-405.12,0Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--portal-2--inject-48"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 250,
    cy: 417.13,
    rx: 84.47,
    ry: 15.19,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.47,417.12c0,1.9-1.93,3.71-5.47,5.39-61.69-11-98.95-3.17-124.71,7.39-23.32-2.71-38.76-7.42-38.76-12.78,0-8.38,37.82-15.18,84.47-15.18S334.47,408.74,334.47,417.12Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.55,417.13c.61-6.08,14.28-9,19.3-10.38,37.26-8,76-7.66,113.77-3.77,55.91,6.36,56.07,21.91,0,28.57-37.79,3.85-76.53,3.9-113.8-4-5.16-1.42-18.66-4.32-19.3-10.38Zm.1,0c.6,5.91,14.32,8.86,19.26,10.11,14.88,3.22,30.1,4.5,45.28,5.21a452.16,452.16,0,0,0,68.35-1.83c55.19-6.19,55.38-20.78,0-27.27a453.47,453.47,0,0,0-91.13.13A204.11,204.11,0,0,0,181.91,407c-5.08,1.28-18.63,4.2-19.26,10.12Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340,417.13c-.59,6.65-14.06,9.91-19.49,11.54-38.44,9.1-78.74,8.7-117.81,4.29-57.16-7.16-57.32-24.49,0-31.95a385.71,385.71,0,0,1,94.58.16,189.71,189.71,0,0,1,23.27,4.41c5.56,1.66,18.86,4.88,19.49,11.55Zm-.1,0c-.62-6.53-14.07-9.79-19.46-11.29-15.34-3.69-31.12-5.16-46.84-6a423,423,0,0,0-70.82,2.08c-56.46,7-56.64,23.38,0,30.64a424,424,0,0,0,94.41-.12,193,193,0,0,0,23.28-4c5.5-1.52,18.83-4.78,19.46-11.28Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340,417.13c-.49-19.83-.5-41.65,0-61.47.49,19.82.49,41.64,0,61.47Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.68,400.27c-.49-19.82-.5-41.64,0-61.47.5,19.83.49,41.65,0,61.47Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160,417.13c-.49-32.59-.49-69.16,0-101.75.49,32.59.49,69.16,0,101.75Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.77,410.54c-.49-24.5-.5-52,0-76.51.49,24.51.48,52,0,76.51Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.73,396c-.5-14.85-.49-30.45,0-45.32.5,14.87.51,30.47,0,45.32Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300,403.14c-.49-18.19-.49-38.2,0-56.39.5,18.19.49,38.2,0,56.39Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.36,408.53c-.49-24.51-.5-52,0-76.51.49,24.5.48,52,0,76.51Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340,326.72a170.52,170.52,0,0,1,0,22.83,168.87,168.87,0,0,1,0-22.83Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.46,373.18a170.52,170.52,0,0,1,0,22.83,168.87,168.87,0,0,1,0-22.83Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.13,360.48a170.67,170.67,0,0,1,0,22.84,169,169,0,0,1,0-22.84Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.9,376a168.87,168.87,0,0,1,0,22.83,170.52,170.52,0,0,1,0-22.83Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.75,374.32a169,169,0,0,1,0,22.84,170.67,170.67,0,0,1,0-22.84Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.68,428.37c2.4-.3,20.82-2.71,11.2-5.89-5.24-1.71-13.24-2.18-18.76-2.8,6.35.35,12.77.48,18.91,2.33,1.28.39,4.36,1.66,2.59,3.28a11.4,11.4,0,0,1-4.49,1.79,65.45,65.45,0,0,1-9.45,1.29Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.2,429.17c4.43-.34,8.83-.47,13.27-.44a59.51,59.51,0,0,1-13.27.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.1,427.47a64.85,64.85,0,0,1,8.89,1.11,28.12,28.12,0,0,1-8.89-1.11Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.2,419.44c-5.46.2-10.91.42-16.34.94-2.72.24-5.43.56-8.11,1-2.29.47-4.78.75-6.76,2.07a1.17,1.17,0,0,0-.52.84,1.21,1.21,0,0,1,.48-.89c1.92-1.47,4.43-1.86,6.73-2.4,2.69-.54,5.41-.86,8.13-1.13a133.82,133.82,0,0,1,16.39-.45Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.79,426.68c1.52-.23,15-1.7,7.89-3.37-4.28-1.06-8.95-1.21-13.34-1.71,5,.22,10.3,0,15.11,1.79,4,2.59-8.38,3.28-9.66,3.29Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.2,427.15a44.28,44.28,0,0,1,9.56-.26,45,45,0,0,1-9.56.26Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.85,426.16a20,20,0,0,1,6.4.64,20.27,20.27,0,0,1-6.4-.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.2,421.46c-3.88.37-7.78.3-11.65.7-3.06.36-7.93.36-10.74,1.63a.75.75,0,0,0-.46.52.82.82,0,0,1,.42-.59c3.28-1.69,7.14-1.59,10.74-2.06,3.88-.34,7.8-.23,11.69-.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.78,251s11.2,19.49,18.75,30.28,15.84,34.31,17.44,36.59,4.4,115.48,4.4,115.48-18.34,2.28-22.18,2.49-22.13,4.94-22.13,4.94l37-3-14.76,3s24.62-1.07,25.8-1.17,9.87.44,10.29.13,1.72-2.21,1.34-3-7.32-3.7-7.32-3.7,2.3-110.61,2.15-112.55,2-4.84.76-6.77-5.33-3.74-5.94-5.12-6.4-38.31-7-54.9C353.15,246.37,318.51,240.72,314.78,251Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.78,251s11.2,19.49,18.75,30.28,15.84,34.31,17.44,36.59,4.4,115.48,4.4,115.48-18.34,2.28-22.18,2.49-22.13,4.94-22.13,4.94l37-3-14.76,3s24.62-1.07,25.8-1.17,9.87.44,10.29.13,1.72-2.21,1.34-3-7.32-3.7-7.32-3.7,2.3-110.61,2.15-112.55,2-4.84.76-6.77-5.33-3.74-5.94-5.12-6.4-38.31-7-54.9C353.15,246.37,318.51,240.72,314.78,251Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.81,278.57l-36.49-19.82c-2.7-4.52-4.54-7.73-4.54-7.73,3.73-10.31,38.36-4.65,38.64,2.69C353.65,260.07,354.64,269.4,355.81,278.57Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.51,339.83s1.85.21,4.79.47c0-.16,0-.32,0-.47ZM346.1,306.65c.16.37.32.74.47,1.11h0a54.86,54.86,0,0,0,8.69-1.11Zm8.54-37.94s0-.11,0-.16h-5.2s.81.1,2.22.23l3,.28h0C354.67,268.94,354.65,268.83,354.64,268.71ZM336.8,286.63c.09.18.19.36.29.54,1-.15,2-.33,2.94-.54Zm20-.54v0h-2.66s1,.12,2.69.28Zm1.14,8H347.64s4.4.51,10.45.9C358,294.66,358,294.36,358,294.06Zm-24.6-13,.17.24.33.48.33.49h0a61,61,0,0,0,11-1.21Zm23.86,71.71s3.1.28,7.84.58h0c0-.2,0-.38,0-.58Zm1.41,36.34a53.55,53.55,0,0,0,5.71,1c0-.31,0-.65,0-1ZM337.88,276.54s6.45,2.9,9.71,0Zm17.4,80.09s6.44,2.9,9.7,0Zm-3.54-31.28c0,.42.06.85.08,1.29a17.68,17.68,0,0,0,7.23-1.29Zm.3,5.36v0c0,.09,0,.17,0,.26l1.89-.3Zm3,89.87c0,.16,0,.33,0,.49,1.19-.14,2.32-.31,3.39-.49Zm3.85-43.88s2.18.19,5.7.43c0-.14,0-.29,0-.43Zm-4.12,33.63c0,.22,0,.43,0,.64,1.68-.18,3.27-.39,4.72-.64Zm-.21-7.28,0,1a79.67,79.67,0,0,0,8.93-1Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.65,251s17.07,21.23,24.62,32,24.3,32.57,25.91,34.85S414,433.37,414,433.37s-18.34,2.28-22.18,2.49-22.14,4.94-22.14,4.94l37-3-14.75,3s24.62-1.07,25.8-1.17,9.87.44,10.29.13,1.71-2.21,1.33-3-7.31-3.7-7.31-3.7S403,322.45,402.81,320.51s2-4.84.76-6.77-5.34-3.74-5.95-5.12-20.72-38.31-21.33-54.9C376,246.37,341.39,240.72,337.65,251Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.65,251s17.07,21.23,24.62,32,24.3,32.57,25.91,34.85S414,433.37,414,433.37s-18.34,2.28-22.18,2.49-22.14,4.94-22.14,4.94l37-3-14.75,3s24.62-1.07,25.8-1.17,9.87.44,10.29.13,1.71-2.21,1.33-3-7.31-3.7-7.31-3.7S403,322.45,402.81,320.51s2-4.84.76-6.77-5.34-3.74-5.95-5.12-20.72-38.31-21.33-54.9C376,246.37,341.39,240.72,337.65,251Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406,339.83h-3.29s1.25.14,3.34.33C406.08,340.05,406.06,339.94,406,339.83Zm-26.33-33.18q.38.48.72,1a47.78,47.78,0,0,0,6.65-1Zm-.43-39.12a.13.13,0,0,1,0-.07l-.09-.26H374s1.49.17,3.94.4l1.4.12h0A.82.82,0,0,1,379.28,267.53Zm-15.71,17.35c.2.29.42.6.65.9l.12.17a54.34,54.34,0,0,0,8.07-1.07Zm28.68,13.18h-4.2s1.69.2,4.42.43C392.39,298.35,392.32,298.21,392.25,298.06Zm-31.39-17c.3.41.59.81.86,1.2a60.47,60.47,0,0,0,10.69-1.2Zm47.49,72.29c-.13-.2-.28-.38-.43-.58h-8.46s3.55.32,8.91.65h0S408.38,353.37,408.35,353.35Zm8.36,48.59h-4.86s1.87.16,4.93.38C416.76,402.2,416.74,402.07,416.71,401.94Zm3.84,22.22c0-.18-.07-.37-.1-.56h-6.68a53.94,53.94,0,0,0,6.87,1.1Zm-2.93-17h-7.79a54.66,54.66,0,0,0,8,1.18C417.75,408,417.68,407.58,417.62,407.18ZM381.39,273.53c-.08-.2-.15-.39-.22-.59H368.11a46.11,46.11,0,0,0,11,1.26l.88-.05c.52,0,1-.08,1.54-.15Zm16.13,83.1s6.45,2.9,9.71,0ZM347,262.82l1,1.26a25.84,25.84,0,0,0,6.14-.4,11,11,0,0,0,1.48-.38h0a9.49,9.49,0,0,0,1.23-.47Zm43.19,62.53c.07.29.14.58.22.88l.06.26c3.65.31,7.92.24,10.82-1.14Zm1.27,5.36c0,.2.1.42.15.63,1.63-.17,3.17-.38,4.59-.63Zm20.9,46H401.14l.6.05h0c1.48.12,5.49.45,10.73.73C412.45,377.22,412.4,377,412.36,376.7Zm-9.75,4,.09.4h0c.9-.12,1.75-.25,2.58-.4ZM411,419.28q.09.44.18.84h0c2.46-.2,4.75-.47,6.8-.84Zm-6.82-31.46c.07.3.13.6.2.9h0c2.75-.21,5.31-.5,7.58-.9Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.89,311.29h0q0,11.64-.18,22c-.46,27.54-1.75,48.58-3.08,63.71-1.4,15.88-2.86,25.26-3.46,28.8-3.95.22-8,.39-12.2.5.69-3.31,2.73-13.7,4.56-29.86a550.09,550.09,0,0,0,3.29-60.41q0-6.51-.14-13.38-.1-5.46-.33-11.14c0-.09,0-.17,0-.26Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.89,311.29h0q0,11.64-.18,22c-.46,27.54-1.75,48.58-3.08,63.71-1.4,15.88-2.86,25.26-3.46,28.8-3.95.22-8,.39-12.2.5.69-3.31,2.73-13.7,4.56-29.86a550.09,550.09,0,0,0,3.29-60.41q0-6.51-.14-13.38-.1-5.46-.33-11.14c0-.09,0-.17,0-.26Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.36,405.12a8.05,8.05,0,0,0,3.74-4.51,11.08,11.08,0,0,0,.39-2c0-.1-.14-.11-.16,0a9.2,9.2,0,0,1-.68,1.81,11.7,11.7,0,0,1-.94,1.65,12.5,12.5,0,0,1-2.51,2.77C264.06,405,264.21,405.21,264.36,405.12Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.36,394.55a5,5,0,0,0,2.2-2,6.25,6.25,0,0,0,.6-1.35,3.64,3.64,0,0,0,.22-1.42c0-.08-.12-.07-.15,0-.19.41-.31.85-.51,1.27a7.86,7.86,0,0,1-.71,1.18c-.26.36-.53.71-.82,1a10.47,10.47,0,0,1-1,1A.18.18,0,0,0,268.36,394.55Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.52,394.61a5.19,5.19,0,0,0,2.25,2.22.25.25,0,0,0,.27-.42,25.69,25.69,0,0,1-2-2.16,7.82,7.82,0,0,1-1.35-2.63c0-.08-.17-.05-.15,0A8.16,8.16,0,0,0,277.52,394.61Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275,386.46a9.58,9.58,0,0,0,.35,1.3,3.07,3.07,0,0,0,1.27,1.94c.33.17.54-.32.24-.51a1.84,1.84,0,0,1-.61-.77,10.71,10.71,0,0,1-.47-1c-.14-.37-.29-.74-.41-1.12s-.23-.79-.37-1.17a.08.08,0,0,0-.16,0A6,6,0,0,0,275,386.46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.92,385.13c.27.09.37-.32.15-.45a8.89,8.89,0,0,1-4.32-5.19c0-.09-.16-.06-.15,0A6.58,6.58,0,0,0,281.92,385.13Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.85,378.9c.19.2.53-.11.36-.32a6,6,0,0,1-1.49-4.23.08.08,0,0,0-.16,0A5.41,5.41,0,0,0,278.85,378.9Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.74,382.74a5.94,5.94,0,0,0,2.58-1.87,8.22,8.22,0,0,0,1.5-2.87c0-.1-.11-.13-.15,0a7.71,7.71,0,0,1-1.69,2.57,14.45,14.45,0,0,1-1.08,1c-.41.33-.86.59-1.29.89C267.46,382.51,267.53,382.8,267.74,382.74Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.64,385.13a8.09,8.09,0,0,0,1.27-1.28,15.32,15.32,0,0,0,1-1.5.08.08,0,0,0-.13-.08,17,17,0,0,1-2.38,2.63A.16.16,0,0,0,268.64,385.13Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.06,371.11a8.11,8.11,0,0,0,2.66-2.74,17.11,17.11,0,0,0,1.48-3.91c0-.09-.12-.13-.15,0a19.78,19.78,0,0,1-1.73,3.59,13.83,13.83,0,0,1-2.45,2.84A.17.17,0,0,0,267.06,371.11Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.68,374.19a7.2,7.2,0,0,0,1.87-2.13,9.67,9.67,0,0,0,1-2.66c0-.1-.12-.12-.15,0a10.15,10.15,0,0,1-1.28,2.44,16.09,16.09,0,0,1-1.69,2.09C267.26,374.06,267.5,374.33,267.68,374.19Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.7,372.49c.1.13.35,0,.27-.14a10.74,10.74,0,0,1-1.45-5.79c0-.1-.14-.13-.15,0C274.16,368.58,274.31,370.85,275.7,372.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281,364.59a.22.22,0,0,0,.31-.29,38.84,38.84,0,0,1-2.45-3.87,20.11,20.11,0,0,1-1.66-4.31c0-.09-.15-.05-.15,0A12.35,12.35,0,0,0,281,364.59Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.48,366.07c.16.12.43-.08.27-.25a7.52,7.52,0,0,1-1.1-1.47,4.23,4.23,0,0,1-.5-1.81c0-.1-.16-.08-.16,0A4.32,4.32,0,0,0,278.48,366.07Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.67,358.51a11.68,11.68,0,0,0,3-8.37c0-.08-.14-.09-.15,0a23.69,23.69,0,0,1-3,8.26C271.45,358.5,271.59,358.59,271.67,358.51Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274,360a4.79,4.79,0,0,0,.39-.94,5.8,5.8,0,0,0,.19-.94c0-.31.06-.62.06-.93s0-.32,0-.48a3.9,3.9,0,0,1,0-.59c0-.12-.18-.11-.15,0a2.24,2.24,0,0,1,0,.52l-.06.48c-.05.31-.1.63-.17.94s-.15.62-.23.93-.15.62-.24.92S274,360.14,274,360Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.88,348.71c.19.09.38-.18.21-.31a12.05,12.05,0,0,1-3.56-6c0-.08-.16-.05-.15,0C278.81,344.86,279.47,347.59,281.88,348.71Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.6,341.31a.19.19,0,0,0,.07-.35,11.64,11.64,0,0,1-3-1.47,6.64,6.64,0,0,1-2.17-2.64c0-.09-.18,0-.14,0C279.08,339.12,281.14,341.24,283.6,341.31Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266,346.41a13.93,13.93,0,0,0,6.21-9.76.08.08,0,1,0-.15,0,18.08,18.08,0,0,1-6.24,9.53A.16.16,0,0,0,266,346.41Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.46,349.32a6.47,6.47,0,0,0,2.79-2.34,8.69,8.69,0,0,0,1.51-3.33.09.09,0,0,0-.17,0,11.19,11.19,0,0,1-1.73,3.11,10,10,0,0,1-1.18,1.26c-.44.41-.91.78-1.34,1.18C268.26,349.23,268.36,349.35,268.46,349.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.42,353.84a5.72,5.72,0,0,0,1.55-3.41c0-.1-.13-.12-.15,0a8.81,8.81,0,0,1-.64,1.71,12.92,12.92,0,0,1-1,1.55A.13.13,0,0,0,269.42,353.84Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276,341.37c.08.14.32,0,.26-.14a16.23,16.23,0,0,1-.73-2.27,8.49,8.49,0,0,1-.2-2.41c0-.09-.15-.1-.16,0A7.62,7.62,0,0,0,276,341.37Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.5,331.15c.24.07.33-.27.13-.39a8.72,8.72,0,0,1-2.45-1.94,5.62,5.62,0,0,1-1.26-2.91.08.08,0,0,0-.16,0C278.86,328.11,280.28,330.58,282.5,331.15Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.38,329.79a14.22,14.22,0,0,0,4.34-5.74.08.08,0,1,0-.14-.07,22.69,22.69,0,0,1-4.4,5.59C268.05,329.69,268.24,329.89,268.38,329.79Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.53,331.76a13,13,0,0,0,2.38-3.83.08.08,0,0,0-.14-.06c-.74,1.29-1.64,2.47-2.46,3.7A.15.15,0,0,0,269.53,331.76Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.29,322.4c.15,0,.27-.22.09-.28a7.37,7.37,0,0,1-4.63-3.65c0-.09-.19-.05-.15,0C280.36,320.45,282.1,322.28,284.29,322.4Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.2,318.38a7.76,7.76,0,0,0,.86.95,5.62,5.62,0,0,0,1.05.76c.15.09.27-.16.12-.25a10.08,10.08,0,0,1-1-.7,5.56,5.56,0,0,1-.9-.85C281.26,318.22,281.13,318.3,281.2,318.38Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269,323a6,6,0,0,0,2.58-3.32.07.07,0,0,0-.14-.05,6.46,6.46,0,0,1-2.56,3.2C268.75,322.92,268.86,323.09,269,323Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.58,409.76a.24.24,0,0,0,.32-.36,20.29,20.29,0,0,1-2.7-3.5,12.85,12.85,0,0,1-1.51-4.19c0-.09-.16-.08-.15,0C274.66,404.73,276,408,278.58,409.76Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.42,411.91a.16.16,0,0,0,.25-.21,7.26,7.26,0,0,1-1.65-4.34.08.08,0,0,0-.16,0A5.74,5.74,0,0,0,274.42,411.91Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.15,414a15.62,15.62,0,0,0,3.71-8.55c0-.09-.13-.12-.15,0a38.51,38.51,0,0,1-3.8,8.37C266.82,413.92,267,414.14,267.15,414Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.81,418.18a8.1,8.1,0,0,0,1.18-2.11,9.29,9.29,0,0,0,.49-2.34.08.08,0,1,0-.15,0,11.45,11.45,0,0,1-.7,2.22,14.36,14.36,0,0,1-1.07,2.06A.15.15,0,0,0,267.81,418.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.45,415a8.81,8.81,0,0,0,4.29-5.57.07.07,0,0,0-.14,0,11.34,11.34,0,0,1-1.8,3,17.07,17.07,0,0,1-2.53,2.35A.17.17,0,0,0,262.45,415Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.15,426.81a7,7,0,0,0,2.28-2.62,10.19,10.19,0,0,0,1.14-3.3c0-.09-.12-.12-.15,0a13.44,13.44,0,0,1-1.42,3.08c-.59,1-1.36,1.78-2,2.68A.13.13,0,0,0,263.15,426.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276,424.63c.14.08.35-.1.21-.24a17.08,17.08,0,0,1-2.91-3.6,11.29,11.29,0,0,1-1.47-4.41.08.08,0,0,0-.15,0C271.79,419.53,273.22,423,276,424.63Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275,419.4a5.57,5.57,0,0,0,.67.85,3.85,3.85,0,0,0,.89.67c.2.12.41-.17.21-.3a5.48,5.48,0,0,1-2.38-3.27.08.08,0,0,0-.16,0A5.4,5.4,0,0,0,275,419.4Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.65,259.89C420,263,439.94,244.8,445.24,233.71s8.94-26.32,7.45-30.13-11.59,16.23-11.59,16.23,9.93-34.43,6.46-39.56S427.2,213,427.2,213s7.51-26.86,3.91-27.41c-5.83-.89-17.19,33.07-17.19,33.07s3.34-14.1-.13-13.27C408.24,206.73,390.8,258.75,398.65,259.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.65,259.89c13.71,1.91,27.17-4.75,37-13.94a47.17,47.17,0,0,0,8.55-10.5,75.49,75.49,0,0,0,5.15-12.56,80.94,80.94,0,0,0,3.17-13.19,16.15,16.15,0,0,0,0-5.8c-.51-2.15-4,3.54-4.47,4.2-2.41,3.83-4.55,7.84-6.6,11.87l-.68-.26c1.49-5.69,10.14-36.64,6-39.47-1,.22-1.83,1.3-2.55,2.11-3.08,3.92-5.4,8.41-7.77,12.8-3.11,5.92-6,12-8.78,18.06l-.87-.31c1.47-5.33,2.81-10.7,3.86-16.11a52.91,52.91,0,0,0,1.07-8.15c0-.86.06-2-.51-2.6-2.87-.41-6.46,7.36-7.71,9.67a211.91,211.91,0,0,0-9.34,23l-.4-.12c3.78-16.46-.09-17.59-6.61-2.12-2.58,5.43-15.35,41.32-8.46,43.38Zm0,0c-6.92-2,5.79-38.08,8.31-43.44,6.54-16.14,10.93-14.41,7.16,2.28l-.4-.11a213.91,213.91,0,0,1,9.15-23.19,48.9,48.9,0,0,1,4.15-7.26,7.63,7.63,0,0,1,3.24-2.87c4.09-1.24,1.42,9.66,1.2,11.65-1,5.46-2.37,10.84-3.82,16.19l-.86-.31c2.75-6.13,5.64-12.19,8.75-18.15,2.89-5.11,5.37-10.75,9.76-14.8,6.77-4.2,1.63,17.9,1.13,20.5-1.42,6.57-3.12,13.07-5,19.53l-.67-.27c1-1.62,10.54-21.07,12.24-15.9a16.3,16.3,0,0,1,0,6,86.38,86.38,0,0,1-8.59,25.8c-9.34,14.81-27.75,26.79-45.73,24.32Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.24,233.71a39.54,39.54,0,0,1-6.34,9h0c5.93-6.9,11.33-26.4,8.86-27.25S436.8,229,436.8,229s2.8-17.79-.85-18.7-11.61,13.19-11.61,13.19.4-14.17-2-13.92-9.58,17.22-9.58,17.22.19-10.11-2-10-7.1,9.84-9,14c4-12.62,9.33-24.68,12-25.3,3.38-.81.3,12.53.14,13.24.38-1.12,11.45-33.92,17.18-33,3.51.53-3.55,26.07-3.9,27.36.68-1.49,16.94-37.76,20.35-32.72s-6.2,38.64-6.46,39.54c.29-.55,10.12-20,11.58-16.2S450.54,222.62,445.24,233.71Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.36,307.76c-5.81,5.05-10,16.68-8.39,18.88s5.79-8.45,5.79-8.45-4.6,23.21-.31,23.05c2.79-.1,5.37-12.4,5.37-12.4s.95,19.06,5.79,18c3.73-.83,1-18.1,1-18.1s3.62,9.83,6.41,8.69-2.79-15.72-2.79-15.72,2.79,5.59,4.34,4.29-1.93-14.81-5.72-18.23S270.36,307.76,270.36,307.76Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.4,314.27c.15,4-.16,10.37,1.13,10.21s2.11-10.21,2.11-10.21.8,13.61,2.1,13.61,2.76-12.15,2.76-12.15.52,8.58,2,8.26,2.42-35.94,1.94-47c-.6-14.09,9.52-17.49,24.91-16.68s66.09,3.56,80,3.4,27-3.56,27.38-5.67-20.57-56.86-39.53-72.41S327.58,156,291.62,158.44s-43.38,12-39.69,40.33c2,15.39,13.65,46.75,17.25,75.41C271.42,292,270.05,305.07,270.4,314.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.1,184.27c-8.81,9.68-8.89,21.77,12.64,50s50.38,46.49,53.94,46.16-7-11.17-7-11.17,21.87,20.89,24.94,19.44-10-22.68-10-22.68,8.79,10,10.63,8.42-9-21.06-9-21.06,5,7.94,7.13,7c3.12-1.46-2.88-37.57-15.93-59S322.56,176.09,315.1,184.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.1,184.27c-6.87,7.14-6.61,16.19-2.86,24.82,3.45,8.2,8.56,15.58,13.83,22.71a188.42,188.42,0,0,0,37.58,37.57A104.27,104.27,0,0,0,378.52,279c1.68.76,4.94,2.45,2.92-1a55.13,55.13,0,0,0-7-8.51L375,269c5.22,4.89,10.53,9.71,16.11,14.18a39,39,0,0,0,7.31,4.92c.49.22,1.12.3,1.16.13a2.23,2.23,0,0,0,0-1.37,38.26,38.26,0,0,0-3.35-8.14c-2.18-4.22-4.57-8.36-7-12.44l.77-.57a49.15,49.15,0,0,0,8.31,7.88c.46.28,1.23.73,1.65.54.28-1.13-.52-2.76-.88-3.92a158,158,0,0,0-8.16-16.63l.66-.39c.69,1.1,6.23,9.32,7,6.14a24.15,24.15,0,0,0,0-6.74,128.27,128.27,0,0,0-3.34-18c-3.07-11.79-7.08-23.53-13.49-33.94-3.38-5.09-8.41-8.88-13.78-11.72-10.86-5.62-23.17-8.26-35.36-8.57a53.77,53.77,0,0,0-9.14.57c-3,.53-6.18,1.18-8.39,3.36Zm0,0c2.2-2.19,5.43-2.86,8.38-3.41a55,55,0,0,1,9.16-.62c16.87.41,39.23,5.62,49.45,20.18,6.51,10.44,10.57,22.18,13.72,34,.69,2.68,8.47,33.91-.63,24.64a36.5,36.5,0,0,1-4.26-5.49l.65-.4a157.17,157.17,0,0,1,8.29,16.7,11.37,11.37,0,0,1,1,4.12c-1.12,4.35-10.29-6.28-11.63-7.68l.77-.57c2.16,3.74,12.28,19.77,10.22,23-2.51,3.33-22.82-16.65-25.79-19.28L375,269a55,55,0,0,1,7,8.69c3.87,7.7-9.67-1.49-11.46-2.67A184.06,184.06,0,0,1,316,217.13c-5.94-10.38-10.52-23.06-.93-32.86Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.62,266c.36.58,13.08,21.23,10,22.66s-23.38-17.95-24.85-19.34c1,1,10.25,10.77,6.87,11.08-2.79.26-21.12-10.92-39.27-29.34,8,7.49,23.28,17.12,25.76,17s.1-7.28,0-7.58c.41.33,14.1,11.3,17.29,10.44S383,255.76,383,255.76s7.09,7,8.7,6.59-4.79-16.22-5-16.66c.16.17,5.84,6.25,7.71,5.71,3-.87,1.63-14.31,1.63-14.31l.22.47c2.89,12.24,3.68,22,2.08,22.76-1.95.92-6.54-6-7.07-6.88.75,1.37,10.73,19.42,9,21S390,266.37,389.62,266Z",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--portal-1--inject-48"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 250,
    cy: 46.05,
    rx: 84.47,
    ry: 15.19,
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.53,46.05c0-1.9,1.93-3.71,5.47-5.39,61.69,11,98.95,3.17,124.71-7.39C319,36,334.47,40.69,334.47,46.05c0,8.38-37.82,15.18-84.47,15.18S165.53,54.43,165.53,46.05Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.55,46.05c.61-6.08,14.28-9,19.3-10.37,37.26-8,76-7.67,113.77-3.78,55.91,6.37,56.07,21.91,0,28.58-37.79,3.84-76.53,3.89-113.8-4-5.16-1.42-18.66-4.31-19.3-10.38Zm.1,0c.6,5.92,14.32,8.86,19.26,10.11,14.88,3.22,30.1,4.5,45.28,5.22a452.16,452.16,0,0,0,68.35-1.84c55.19-6.19,55.38-20.77,0-27.26a454.21,454.21,0,0,0-91.13.12,206.5,206.5,0,0,0-22.53,3.53c-5.08,1.28-18.63,4.2-19.26,10.12Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340,46.05C339.45,52.7,326,56,320.55,57.59c-38.44,9.1-78.74,8.7-117.81,4.3-57.16-7.17-57.32-24.5,0-31.95a386.2,386.2,0,0,1,94.58.15,191.62,191.62,0,0,1,23.27,4.41c5.56,1.66,18.86,4.89,19.49,11.55Zm-.1,0c-.62-6.53-14.07-9.78-19.46-11.28-15.34-3.69-31.12-5.16-46.84-6a423,423,0,0,0-70.82,2.09c-56.46,7-56.64,23.37,0,30.64a425.15,425.15,0,0,0,94.41-.12,193,193,0,0,0,23.28-4c5.5-1.52,18.83-4.78,19.46-11.29Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160,47.25c.49,19.83.5,41.65,0,61.47-.49-19.82-.49-41.64,0-61.47Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.32,64.1c.49,19.83.5,41.65,0,61.47-.5-19.82-.49-41.64,0-61.47Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340,47.25c.49,32.59.49,69.16,0,101.75-.49-32.59-.49-69.16,0-101.75Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.23,53.84c.49,24.5.5,52,0,76.51-.49-24.51-.48-52,0-76.51Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.27,68.37c.5,14.85.49,30.45,0,45.31-.5-14.86-.51-30.46,0-45.31Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.05,61.24c.49,18.18.49,38.2,0,56.39-.5-18.19-.49-38.21,0-56.39Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.64,55.85c.49,24.5.5,52,0,76.51-.49-24.5-.48-52,0-76.51Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160,137.66a170.52,170.52,0,0,1,0-22.83,168.87,168.87,0,0,1,0,22.83Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.54,91.2a170.52,170.52,0,0,1,0-22.83,168.87,168.87,0,0,1,0,22.83Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.87,103.89a170.52,170.52,0,0,1,0-22.83,168.87,168.87,0,0,1,0,22.83Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.1,88.39a168.87,168.87,0,0,1,0-22.83,170.52,170.52,0,0,1,0,22.83Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.25,90.05a168.87,168.87,0,0,1,0-22.83,170.52,170.52,0,0,1,0,22.83Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288,45.49c2.4-.3,20.81-2.72,11.2-5.89-5.24-1.72-13.24-2.19-18.76-2.8,6.35.34,12.76.48,18.91,2.33,1.28.39,4.36,1.65,2.59,3.28a11.4,11.4,0,0,1-4.49,1.79A65.45,65.45,0,0,1,288,45.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.47,46.29c4.43-.34,8.83-.48,13.27-.44a59.51,59.51,0,0,1-13.27.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.37,44.59a64.85,64.85,0,0,1,8.89,1.11,28.12,28.12,0,0,1-8.89-1.11Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.47,36.56c-5.46.2-10.91.42-16.34.94-2.72.24-5.43.56-8.11,1-2.29.46-4.78.75-6.77,2.07a1.19,1.19,0,0,0-.51.83,1.2,1.2,0,0,1,.47-.88c1.92-1.47,4.44-1.86,6.74-2.4,2.69-.54,5.41-.86,8.13-1.14a133.81,133.81,0,0,1,16.39-.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.06,43.8c1.52-.23,15-1.7,7.89-3.38-4.28-1.05-8.95-1.21-13.34-1.7,5,.22,10.3,0,15.11,1.79,4,2.58-8.38,3.28-9.66,3.29Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.47,44.27A44.2,44.2,0,0,1,280,44a44.85,44.85,0,0,1-9.55.26Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.12,43.27a20.31,20.31,0,0,1,6.4.65,20,20,0,0,1-6.4-.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.47,38.58c-3.88.37-7.78.3-11.66.7-3.05.36-7.92.35-10.74,1.62-.19.12-.42.27-.45.52a.84.84,0,0,1,.41-.58c3.29-1.69,7.15-1.59,10.74-2.06,3.89-.34,7.8-.24,11.7-.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277,40.88c-1.54,9.27-3.67,20.61-5.3,29.06-.25,1.28-.48,2.49-.71,3.62s-.44,2.3-.64,3.28c0,.09,0,.17-.05.25-.08.44-.17.86-.24,1.25s-.12.58-.17.85-.07.33-.1.49l-.49,2.47h0l-11.39-1.41h0l0-.13c.08-.46.39-2.1.85-4.57.05-.23.09-.47.14-.72l.12-.64c.05-.32.11-.64.18-1,.19-1,.39-2.15.61-3.35,1.52-8.28,3.63-20.08,5.21-30C269.17,40.45,273.17,40.64,277,40.88Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277,40.88c-1.54,9.27-3.67,20.61-5.3,29.06-.25,1.28-.48,2.49-.71,3.62s-.44,2.3-.64,3.28c0,.09,0,.17-.05.25-.08.44-.17.86-.24,1.25s-.12.58-.17.85-.07.33-.1.49l-.49,2.47h0l-11.39-1.41h0l0-.13c.08-.46.39-2.1.85-4.57.05-.23.09-.47.14-.72l.12-.64c.05-.32.11-.64.18-1,.19-1,.39-2.15.61-3.35,1.52-8.28,3.63-20.08,5.21-30C269.17,40.45,273.17,40.64,277,40.88Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271,73.56c-1,5.18-1.7,8.59-1.7,8.59l-11.39-1.41s.52-2.74,1.31-7Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.72,66a9.12,9.12,0,0,0-3.51,2,6.16,6.16,0,0,0-1.15,1.79c-.14.34-.29.68-.41,1a10.81,10.81,0,0,1-.55,1.2c-.05.09.09.16.14.07a6,6,0,0,1,.58-1l.66-.88a17.48,17.48,0,0,1,1.25-1.59,14.38,14.38,0,0,1,3.15-2.26A.2.2,0,0,0,275.72,66Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.51,63.37a8.12,8.12,0,0,0-2.43,2.16,12,12,0,0,0-.88,1.35,11.39,11.39,0,0,0-.64,1.48c0,.09.11.14.15.06a14.31,14.31,0,0,1,.84-1.34,10.52,10.52,0,0,1,1-1.24,23.05,23.05,0,0,1,2.21-2.21C274.86,63.5,274.66,63.27,274.51,63.37Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.08,56.84c-.25-.1-.45.29-.25.45,2.1,1.71,3.86,4,4,6.76a.08.08,0,0,0,.16,0C263.28,61.19,261.91,57.9,259.08,56.84Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.68,56.17a4.84,4.84,0,0,0-1.34-2.73.19.19,0,0,0-.31.19,27.89,27.89,0,0,1,1,2.7,9.36,9.36,0,0,1,.27,1.4c0,.25,0,.49.05.74a3.53,3.53,0,0,0,0,.65.09.09,0,0,0,.15,0,3.6,3.6,0,0,0,.28-1.42A6.72,6.72,0,0,0,266.68,56.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.49,49.36a10.1,10.1,0,0,0-5.23,7.58c0,.11.15.15.19.05a20.36,20.36,0,0,1,2.13-4,19.88,19.88,0,0,1,3.1-3.38C276.81,49.47,276.64,49.29,276.49,49.36Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.47,47.57a5.1,5.1,0,0,0-1.61,2.06,7.25,7.25,0,0,0-.43,1.21,4.92,4.92,0,0,0-.21,1.32c0,.1.14.11.18,0,.13-.39.21-.8.36-1.18a8.88,8.88,0,0,1,.55-1.17c.39-.73.91-1.37,1.37-2.07C273.76,47.64,273.59,47.48,273.47,47.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.94,47.59a7.75,7.75,0,0,0-.51-2.07,7,7,0,0,0-2.67-3.2c-.14-.09-.29.12-.17.23a10.79,10.79,0,0,1,2.21,3,9.65,9.65,0,0,1,.65,1.72,8.73,8.73,0,0,1,.21,1c0,.27.16.76,0,1-.06.08,0,.18.11.11a.92.92,0,0,0,.22-.68A6.87,6.87,0,0,0,266.94,47.59Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.58,69.57a3.08,3.08,0,0,0-.82-1.87c-.15-.13-.44,0-.36.22a11.75,11.75,0,0,1,.69,1.69,4.86,4.86,0,0,1,.1,1.86c0,.08.11.15.14.06A4.1,4.1,0,0,0,265.58,69.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.48,69.11a6.14,6.14,0,0,0-1.78-1.88c-.16-.11-.29.13-.19.25a18.66,18.66,0,0,1,1.43,2,19.2,19.2,0,0,1,1.16,2.14c0,.08.18,0,.17-.06A5.94,5.94,0,0,0,260.48,69.11Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.35,111.75c-1.17,2.4,1.69,11.86-.65,14.16-6.44,6.34-19.37,6.34-26.5,5s-19.17-6-22.88-14.28c-1.34-3,4.75-10.76,4.54-13.42s-6.31-4.49-4.46-13.64S242.2,76,247.92,75.66a67.78,67.78,0,0,1,30.25,5.68c5.2,2.4,12.88,10.13,11.28,19.32S281.51,109.36,280.35,111.75Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.35,111.75c-1.17,2.4,1.69,11.86-.65,14.16-6.44,6.34-19.37,6.34-26.5,5s-19.17-6-22.88-14.28c-1.34-3,4.75-10.76,4.54-13.42s-6.31-4.49-4.46-13.64S242.2,76,247.92,75.66a67.78,67.78,0,0,1,30.25,5.68c5.2,2.4,12.88,10.13,11.28,19.32S281.51,109.36,280.35,111.75Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.91,104.82,237,97c.53-1.56,13.93-8.32,22.94-6.63S279,103.18,278.91,104.82Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.91,104.82,237,97a4.53,4.53,0,0,1,1.62-1.38,22.65,22.65,0,0,1,7.61-.61c4.87.7,8.39,3.43,12.07,4.12s7.95-.58,12.74.54A22.93,22.93,0,0,1,277.9,103,4.4,4.4,0,0,1,278.91,104.82Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.84,106.63c-.17.26-4.26-1.88-7.81-1.77-5.14.16-10.38,5.9-17.68,4.53s-10.09-8.62-14.83-10.64c-3.26-1.39-7.86-.87-7.92-1.19S241.16,95.3,246,96s8.34,3.71,12,4.4,8-.81,12.8.27S282,106.36,281.84,106.63Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.2,106.54c-1.71.27-3.68-3.48-1.74-3.89S254.11,106.4,253.2,106.54Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.32,107.88c1.5.87,4.69-1.91,3-3S259.53,107.42,260.32,107.88Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.58,113.77c0,.08.18-.06.19-.14.38-1.95,1.13-4.12,3-4.37.06,0,.08-.1,0-.11C273.6,109,272.63,111.86,272.58,113.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.87,117.24c4.59,1.06,5.9-6.14,1.64-7.13S271,116.35,274.87,117.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.68,117.22c.75-.31,1.54-.94,2.36-.87s1.49,1,1.94,1.9c0,.09.13,0,.15-.06.3-1.45,0-3-1.49-3.57s-2.66.62-3.3,2C276.22,116.89,276.38,117.34,276.68,117.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.32,107.9c0,.07-.14-.12-.13-.2.36-2,.44-4.25-1.23-5.17-.06,0,0-.13,0-.11C242.11,103.05,242,106.1,241.32,107.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.93,110.3c-4.66-.68-3.27-7.86,1.06-7.24S241.85,110.87,237.93,110.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.25,109.62c-.58-.55-1.09-1.43-1.88-1.66s-1.76.41-2.5,1.07c-.08.06-.14,0-.12-.11.25-1.47,1.08-2.86,2.68-2.79s2.26,1.54,2.35,3.07C236.8,109.49,236.49,109.85,236.25,109.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.86,121.44a35.42,35.42,0,0,1-3.36,7.29,32.58,32.58,0,0,1-4.84,6.36c-.07.07,0,.15.09.1a24.6,24.6,0,0,0,5.42-6.09,23.4,23.4,0,0,0,2.84-7.62A.08.08,0,0,0,252.86,121.44Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.57,125.12c-.9,6.72-4.22,13.08-8.3,18.42a.11.11,0,1,0,.16.16c5.2-4.85,7.71-11.58,8.29-18.57C254.73,125.05,254.58,125,254.57,125.12Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.88,126.89a21.34,21.34,0,0,1-1.73,3.91,26.63,26.63,0,0,1-2.37,3.57c0,.06,0,.12.07.07a14,14,0,0,0,2.66-3.43,17,17,0,0,0,1.52-4.08A.08.08,0,0,0,252.88,126.89Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.93,133.84a21.12,21.12,0,0,1-3.88-7.68c0-.07-.14-.06-.13,0a11.37,11.37,0,0,0,1.17,4.24,13.07,13.07,0,0,0,2.72,3.55C260.89,134.05,261,133.93,260.93,133.84Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.64,126c-.45-.95-.86-1.89-1.22-2.87a12.06,12.06,0,0,1-.78-3c0-.12-.18-.11-.2,0a6.32,6.32,0,0,0,.24,3.2,8.27,8.27,0,0,0,1.76,2.78C262.52,126.16,262.7,126.09,262.64,126Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250,114.67c-.17.27-.38.5-.54.77l-.54.82c-.36.54-.73,1.06-1.09,1.58s-.71,1-1.07,1.52-.78,1-1.13,1.57a.12.12,0,0,0,.16.16,11.93,11.93,0,0,0,2.63-2.86,13.58,13.58,0,0,0,1-1.69c.15-.3.29-.59.42-.89s.2-.61.31-.92C250.18,114.64,250.05,114.6,250,114.67Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.65,123.29a6.69,6.69,0,0,1-.76.65c-.26.23-.54.45-.82.66a15.28,15.28,0,0,1-1.67,1.07,21.78,21.78,0,0,1-3.66,1.64.1.1,0,0,0,0,.2,9,9,0,0,0,3.93-1.25,10.47,10.47,0,0,0,1.65-1.24c.25-.23.5-.48.74-.74s.43-.6.67-.88C246.83,123.32,246.71,123.21,246.65,123.29Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.59,127.15a8.26,8.26,0,0,0-1-.75c-.38-.27-.74-.57-1.1-.87a24,24,0,0,1-2-1.9,22,22,0,0,1-1.74-2.12,22.63,22.63,0,0,1-1.38-2.38c-.05-.09-.19,0-.17.07a12.15,12.15,0,0,0,2.69,5A11.22,11.22,0,0,0,280,126a6.87,6.87,0,0,0,2.55,1.27A.08.08,0,0,0,282.59,127.15Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.3,124.13a17.64,17.64,0,0,1-3-7.06.16.16,0,0,0-.31.05,10.85,10.85,0,0,0,3.17,7.1C273.23,124.29,273.35,124.2,273.3,124.13Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.79,130.65a36.39,36.39,0,0,1-3.61-3,30.29,30.29,0,0,1-3.06-3.63.17.17,0,0,0-.29.18,13.13,13.13,0,0,0,2.92,3.9,12.88,12.88,0,0,0,4,2.64C277.79,130.81,277.85,130.7,277.79,130.65Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.37,112.2a18.18,18.18,0,0,1-11,4.26c-.13,0-.16.2,0,.22,4.13.64,8.74-.82,11.22-4.32C239.6,112.27,239.46,112.13,239.37,112.2Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.91,110.52a13.05,13.05,0,0,1-1.58,2.57,19.28,19.28,0,0,1-2,2.24c-.11.1,0,.27.16.2a7.58,7.58,0,0,0,2.29-2.11,8.68,8.68,0,0,0,1.28-2.84C243.08,110.5,243,110.44,242.91,110.52Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.22,117a14,14,0,0,1-3.38,2.83,16.25,16.25,0,0,1-4,1.82c-.05,0,0,.09,0,.08a10.49,10.49,0,0,0,4.27-1.49,11.92,11.92,0,0,0,3.26-3.15C239.4,117,239.28,116.93,239.22,117Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.36,125.26a23.33,23.33,0,0,1-1.12-2.56c0-.1-.16,0-.15,0a10.77,10.77,0,0,0,.86,2.72,8.69,8.69,0,0,0,1.64,2.3c.05.06.15,0,.1-.08C269.21,126.9,268.78,126.08,268.36,125.26Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.42,121.19a22.52,22.52,0,0,1-3.21-7.76c0-.08-.12-.05-.13,0a9.41,9.41,0,0,0,.74,4.29,11,11,0,0,0,2.48,3.55A.08.08,0,0,0,264.42,121.19Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.51,99.78a41.47,41.47,0,0,1-3.51,3.38,21.89,21.89,0,0,1-4.09,2.69c-.1.05,0,.22.08.19a13.11,13.11,0,0,0,7.64-6.16C291.67,99.8,291.57,99.72,291.51,99.78Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.07,100c-.61-.18-1.26-.27-1.88-.43s-1.25-.33-1.87-.53-1.26-.41-1.88-.67-1.18-.56-1.78-.8a.1.1,0,0,0-.12.17,9.22,9.22,0,0,0,3.54,2,8.37,8.37,0,0,0,4,.41C236.16,100.1,236.14,100,236.07,100Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.65,96.64a16.39,16.39,0,0,1-2.47-2.24,17.17,17.17,0,0,1-1.87-2.76c-.06-.11-.2,0-.18.08a6.72,6.72,0,0,0,4.45,5.06A.08.08,0,0,0,232.65,96.64Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.85,91.7c0-.09-.17-.07-.17,0a13.23,13.23,0,0,1-.56,4.42,10.19,10.19,0,0,1-2.14,4,.08.08,0,0,0,.11.11,12.43,12.43,0,0,0,1.57-1.76,9,9,0,0,0,1-2.14A8,8,0,0,0,289.85,91.7Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.61,76.83a3.92,3.92,0,0,0-1-.77,4.5,4.5,0,0,0-1.19-.45.23.23,0,0,0-.17.43,7.52,7.52,0,0,1,1,.56c.31.21.62.41.91.65A7,7,0,0,1,247.68,79a.09.09,0,0,0,.15-.07A4.92,4.92,0,0,0,246.61,76.83Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.67,80.37a.15.15,0,0,0-.27-.11,7.17,7.17,0,0,0-.89,3.71,8.6,8.6,0,0,0,1,3.64.08.08,0,0,0,.14-.06A13.17,13.17,0,0,1,233.67,80.37Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.41,86.15a.28.28,0,0,0-.56,0,6.53,6.53,0,0,0,2,4.88c.07.06.17,0,.12-.1A12.11,12.11,0,0,1,235.41,86.15Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.76,81.6a.19.19,0,0,0-.34.16,32.3,32.3,0,0,1,.74,3.38,13.75,13.75,0,0,1,0,3.51c0,.08.11.15.15.06A7.57,7.57,0,0,0,257.76,81.6Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263,79.48a8.44,8.44,0,0,0-1.71,2.94,12.14,12.14,0,0,0-.56,3.38.08.08,0,0,0,.16,0,16.24,16.24,0,0,1,.95-3.19c.41-1,.83-2,1.32-3C263.17,79.5,263,79.39,263,79.48Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.38,83.82a10.69,10.69,0,0,0-1.62,3.28c0,.08.11.14.14.06A24.25,24.25,0,0,1,264.65,84C264.74,83.86,264.5,83.67,264.38,83.82Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.6,78.32A8.06,8.06,0,0,0,271,79.94a8.48,8.48,0,0,0-2.33,3.19.08.08,0,0,0,.14.08,11.08,11.08,0,0,1,2.59-2.79,12.79,12.79,0,0,1,3.26-1.94A.08.08,0,0,0,274.6,78.32Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.69,96.33c-.39.66-.83,1.3-1.26,1.93a9.07,9.07,0,0,1-1.51,1.76c-.06,0,0,.17.1.12a12.56,12.56,0,0,0,1.75-1.59,6.89,6.89,0,0,0,1.24-2C287.09,96.29,286.81,96.12,286.69,96.33Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.22,88.75c-.06-.25-.4-.16-.41.06,0,.4,0,.8,0,1.19a9.84,9.84,0,0,1-.15,1.2,7.71,7.71,0,0,1-.84,2.26c0,.07.07.16.13.09a7.08,7.08,0,0,0,1.12-2.25A5,5,0,0,0,287.22,88.75Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.73,92.2a18.85,18.85,0,0,1-2.19,4.14c-.06.08,0,.18.11.11a8,8,0,0,0,2.4-4.13C279.08,92.14,278.82,92,278.73,92.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.58,87.13c-.22.84-.43,1.69-.69,2.53a15.51,15.51,0,0,1-1,2.46.09.09,0,0,0,.16.09,10.32,10.32,0,0,0,2-5C278.08,86.9,277.65,86.87,277.58,87.13Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.39,83.64a6.29,6.29,0,0,0-1.86,2,9,9,0,0,0-1.08,2.48.08.08,0,0,0,.14.06A14.44,14.44,0,0,1,273,85.93c.52-.71,1.11-1.35,1.65-2C274.71,83.75,274.56,83.53,274.39,83.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.08,82.87a6,6,0,0,0-2.26-3c-.08-.05-.2.07-.14.15a16.32,16.32,0,0,1,1,1.51c.33.51.65,1,.93,1.58a12.72,12.72,0,0,1,1.17,3.44.08.08,0,0,0,.16,0A11.35,11.35,0,0,0,248.08,82.87Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.12,82.06A10.43,10.43,0,0,0,242.5,81a5,5,0,0,0-1.67-1.76.15.15,0,0,0-.2.21A14.22,14.22,0,0,0,242,81.22c.23.3.46.59.68.9.11.16.22.32.32.49a1.89,1.89,0,0,1,.31.55c0,.08.16.07.15,0A3,3,0,0,0,243.12,82.06Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.17,77.06a8.52,8.52,0,0,0-2.81-2.79.08.08,0,0,0-.1.12,15.2,15.2,0,0,1,2.52,3,11.5,11.5,0,0,1,1.59,3.56c0,.1.16,0,.15,0A10,10,0,0,0,251.17,77.06Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.42,118.88a15.74,15.74,0,0,1-1-2.77,17.54,17.54,0,0,1-.56-2.87.12.12,0,0,0-.23,0,8,8,0,0,0,.24,3,8.16,8.16,0,0,0,1.41,2.69C258.35,119.05,258.46,119,258.42,118.88Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.61,114.53a14,14,0,0,1-1.45,2.41,14.43,14.43,0,0,1-1.84,2.14s0,.11.07.08a6.92,6.92,0,0,0,2.19-1.91,6.84,6.84,0,0,0,1.17-2.66C254.77,114.51,254.64,114.45,254.61,114.53Z",
    style: {
      fill: "#FFC727"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Numbers--inject-48"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M170,384.36a12.23,12.23,0,0,1-12.44,12.21h-2.22v16.89a12.22,12.22,0,0,1-24.44,0V396.57h-70a10.88,10.88,0,0,1-7.55-2.66,11.89,11.89,0,0,1-2-17.1l82.19-102.18c.22,0,.22-.22.44-.45a2.81,2.81,0,0,0,.67-.89,2.34,2.34,0,0,0,1.11-.66c.22-.22.67-.45.89-.67a2.39,2.39,0,0,1,1.33-.44c.22-.45.45-.67.89-.67.22-.22.67-.22,1.33-.44a1.29,1.29,0,0,0,.89-.23h3.78a1.93,1.93,0,0,0,1.11.23c.22.22.89.22,1.33.44.22,0,.67.22.89.22.45.45.89.67,1.11.89.44.22.67.45,1.11.67a.22.22,0,0,1,.22.22c.23,0,.67.22.67.44l.89.89c.22.23.44.67.66.89a5.7,5.7,0,0,1,.89,1.11,1.72,1.72,0,0,0,.45.89,9.82,9.82,0,0,1,.44,1.33c0,.23.22.67.22.89a2.46,2.46,0,0,1,.22,1.34c0,.44.23.66.23,1.11v90.4h2.22A12.38,12.38,0,0,1,170,384.36Zm-39.1-67.08-44.2,54.86h44.2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.08,384.36a12.23,12.23,0,0,1-12.44,12.21h-2.23v16.89a12.22,12.22,0,0,1-24.43,0V396.57H330a10.87,10.87,0,0,1-7.55-2.66,11.89,11.89,0,0,1-2-17.1l82.19-102.18c.22,0,.22-.22.44-.45a3,3,0,0,0,.67-.89,2.34,2.34,0,0,0,1.11-.66c.22-.22.67-.45.89-.67a2.39,2.39,0,0,1,1.33-.44c.22-.45.44-.67.89-.67.22-.22.66-.22,1.33-.44a1.3,1.3,0,0,0,.89-.23H414a1.93,1.93,0,0,0,1.11.23c.22.22.89.22,1.33.44.22,0,.67.22.89.22.45.45.88.67,1.11.89.44.22.66.45,1.11.67a.22.22,0,0,1,.22.22c.22,0,.67.22.67.44l.89.89c.22.23.44.67.66.89a5.7,5.7,0,0,1,.89,1.11,1.72,1.72,0,0,0,.45.89,9.82,9.82,0,0,1,.44,1.33c0,.23.22.67.22.89a2.46,2.46,0,0,1,.22,1.34c0,.44.22.66.22,1.11v90.4h2.23A12.38,12.38,0,0,1,439.08,384.36ZM400,317.28l-44.2,54.86H400Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-48"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.57,151.37a30.74,30.74,0,0,1,51.37-19.44l15.38-2.26-7.7,13.3a30.37,30.37,0,0,1,2.11,14.8,30.75,30.75,0,1,1-61.16-6.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.57,151.37a30.93,30.93,0,0,1,6.2-15.58,27.83,27.83,0,0,1,6-6,30.23,30.23,0,0,1,7.41-4.13,31,31,0,0,1,8.28-2,29,29,0,0,1,4.27-.08,26.53,26.53,0,0,1,4.26.44,31.05,31.05,0,0,1,15.21,7.51l-.37-.11,15.37-2.36,1.11-.17-.56,1-7.65,13.32,0-.52a31.05,31.05,0,1,1-59.61,8.63Zm0,0a30.86,30.86,0,0,0,9.33,25.26,31.18,31.18,0,0,0,11.86,7,30.77,30.77,0,0,0,13.68,1,30.21,30.21,0,0,0,12.69-5,31.63,31.63,0,0,0,9.2-10,30.29,30.29,0,0,0,3.9-13,30.67,30.67,0,0,0-2.16-13.4l-.11-.27.15-.25,7.74-13.27.55.81L209,132.36l-.21,0-.15-.14a30.23,30.23,0,0,0-14.72-7.58,26.67,26.67,0,0,0-4.18-.51,29.44,29.44,0,0,0-4.2,0,30,30,0,0,0-8.21,1.8,28.61,28.61,0,0,0-7.42,4,27.22,27.22,0,0,0-6,5.89A30.86,30.86,0,0,0,157.57,151.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.23,159.28V163a2.77,2.77,0,0,1-2.83,2.83,2.84,2.84,0,0,1-2.84-2.83v-6c0-.06.06-.06.06-.11s-.06-.06-.06-.12A2.92,2.92,0,0,1,187.4,154a6.48,6.48,0,1,0,0-12.95,6.41,6.41,0,0,0-5.55,3.18,2.85,2.85,0,0,1-3.93,1,2.81,2.81,0,0,1-1-3.87,12.14,12.14,0,1,1,13.29,17.91Zm0,12.66v1a2.77,2.77,0,0,1-2.83,2.83,2.84,2.84,0,0,1-2.84-2.83v-1a2.88,2.88,0,0,1,2.84-2.83A2.8,2.8,0,0,1,190.23,171.94Z",
    style: {
      fill: "#FFC727"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404ErrorwithportalsCuate);
export default __webpack_public_path__ + "static/media/404 error with portals-cuate.b7c8ba50ff571c02f67aaf8690d3abb8.svg";
export { ForwardRef as ReactComponent };